import * as React from "react"
import type { SVGProps } from "react"
const SvgForm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 20.29q-.82 0-1.41-.6A2 2 0 0 1 3 18.3v-12q0-.82.59-1.42A2 2 0 0 1 5 4.3h14q.83 0 1.41.58.6.6.59 1.42v12q0 .83-.59 1.4a2 2 0 0 1-1.41.6zm0-2h14v-10H5zm3-6a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 8 10.3h8q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm0 4a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 8 14.3h4a.97.97 0 0 1 1 1q0 .42-.29.7a1 1 0 0 1-.71.3z" />
  </svg>
)
export default SvgForm
